const normalizeUTF16Offset = value => {
  const number = Number(value)
  if (!Number.isFinite(number)) return 0
  return Math.max(0, Math.trunc(number))
}

const findUTF16Boundary = (root, requestedOffset) => {
  let remaining = normalizeUTF16Offset(requestedOffset)

  const visit = parent => {
    const children = Array.from(parent.childNodes || [])
    for (let index = 0; index < children.length; index += 1) {
      const child = children[index]
      if (child.nodeType === Node.TEXT_NODE) {
        const length = String(child.nodeValue || '').length
        if (remaining <= length) {
          return { node: child, offset: remaining }
        }
        remaining -= length
        continue
      }

      if (child.nodeName === 'BR') {
        if (remaining === 0) return { node: parent, offset: index }
        remaining -= 1
        if (remaining === 0) return { node: parent, offset: index + 1 }
        continue
      }

      const nested = visit(child)
      if (nested) return nested
    }
    return null
  }

  return visit(root) || {
    node: root,
    offset: (root.childNodes || []).length
  }
}

const setContentEditableCaretUTF16 = (
  root,
  requestedOffset,
  selection = window.getSelection()
) => {
  if (!root || !selection) return false

  const boundary = findUTF16Boundary(root, requestedOffset)
  const range = document.createRange()
  range.setStart(boundary.node, boundary.offset)
  range.collapse(true)
  selection.removeAllRanges()
  selection.addRange(range)
  return true
}

const focusAndSetContentEditableCaretUTF16 = (
  root,
  requestedOffset,
  selection = window.getSelection()
) => {
  if (!root) return false
  root.focus()
  return setContentEditableCaretUTF16(root, requestedOffset, selection)
}

export {
  findUTF16Boundary,
  focusAndSetContentEditableCaretUTF16,
  normalizeUTF16Offset,
  setContentEditableCaretUTF16
}
